var map = {
	"./btc.png": "9bbf",
	"./dai.png": "38f7",
	"./eth.png": "d73f",
	"./icon-eth-blue.png": "c319",
	"./knc.png": "a6b0",
	"./link.png": "6814",
	"./rif-logo.png": "e54a",
	"./usdc.png": "a41f",
	"./usdt.png": "a0ad"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "26ca";